export const WARNINGS = 'FETCH_WARNINGS';

export const warningTypes = {
    FETCH_REQUEST: `${WARNINGS}_REQUEST`,
    FETCH_SUCCESS: `${WARNINGS}_SUCCESS`,
    FETCH_FAILURE: `${WARNINGS}_FAILURE`,
};


